import type { OversightResultDocumentByDocumentIdResponseRow as OversightAssessmentDocumentOversightResultsByDocumentIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightAssessmentDocumentAssessmentResultsByDocumentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentDocumentAssessmentResultsByDocumentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetDocumentOversightResultsByDocumentIdArgs = {
  documentId: string;
};

export const useLazyGetDocumentOversightResultsByDocumentId =
  createLazyQueryHook<
    UseLazyGetDocumentOversightResultsByDocumentIdArgs,
    OversightAssessmentDocumentOversightResultsByDocumentIdResponseRow[],
    GetOversightAssessmentDocumentAssessmentResultsByDocumentIdQuery
  >({
    trpcQuery: (client, { documentId }) =>
      client.frontend.assessment.oversightAssessmentDocumentAssessmentResultsByDocumentId.query(
        { documentId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      document_oversight_result: data,
    }),
    graphqlDocument:
      GetOversightAssessmentDocumentAssessmentResultsByDocumentIdDocument,
    graphqlVariables: ({ documentId }) => ({ ParentId: documentId }),
    graphqlFetchPolicy: 'no-cache',
  });
